import { xhrFormRecaptcha } from "@jeffcarbine/premmio/public/modules/xhr/xhr.js";
import { addEventDelegate } from "@jeffcarbine/premmio/public/modules/eventDelegate/eventDelegate.js";

const submitContactForm = (form) => {
  xhrFormRecaptcha({ form });
};

addEventDelegate("submit", "#contact", submitContactForm, true);
